// extracted by mini-css-extract-plugin
module.exports = {"container":"Multiview_container__1c5aB","display":"Multiview_display__2Vmv2"};